"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usuarioSistemaInvitacionConverter = void 0;
const usuarioSistemaInvitacionConverter = {
    toFirestore(usuarioInvitacion) {
        return usuarioInvitacion;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            mail: data.mail,
            nombre: data.nombre,
            vendedor: data.vendedor,
            vendedorRestringido: data.vendedorRestringido,
            locales: data.locales,
            empresaLogoURL: data.empresaLogoURL,
            empresaNombreComercial: data.empresaNombreComercial,
            empresaRazonSocial: data.empresaRazonSocial,
            empresaRUT: data.empresaRUT,
            empresaId: data.empresaId,
            enviadaPorNombre: data.enviadaPorNombre,
            enviadaPorMail: data.enviadaPorMail,
            enviadaEl: data.enviadaEl?.seconds,
            enviadaElString: data.enviadaElString,
            rolId: data.rolId
        };
    }
};
exports.usuarioSistemaInvitacionConverter = usuarioSistemaInvitacionConverter;
